export const CONSTS = {
  labelsPageSize: 30,
}
